module.exports = __webpack_public_path__ + "img/nunito-sans-v6-latin-200.8e4fee6b.svg";